/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_IntroInputs */

const en_viewer_ref_intro = /** @type {(inputs: Viewer_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What each value in a document is labelled as, and how its path is written.`)
};

const ko_viewer_ref_intro = /** @type {(inputs: Viewer_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 안의 각 값에 어떤 타입이 표시되는지, 그리고 경로가 어떻게 쓰이는지입니다.`)
};

const ja_viewer_ref_intro = /** @type {(inputs: Viewer_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書内の各値にどの型が表示されるか、そしてパスがどう書かれるかです。`)
};

/**
* | output |
* | --- |
* | "What each value in a document is labelled as, and how its path is written." |
*
* @param {Viewer_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_intro = /** @type {((inputs?: Viewer_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_intro(inputs)
	if (locale === "ko") return ko_viewer_ref_intro(inputs)
	return ja_viewer_ref_intro(inputs)
});